import { useScrollAnimation } from '@/hooks/useScrollAnimation';

const cities = [
  { name: 'Austin', tag: 'Primary Market', featured: true },
  { name: 'Round Rock', tag: 'Full Service' },
  { name: 'Cedar Park', tag: 'Full Service' },
  { name: 'Pflugerville', tag: 'Full Service' },
  { name: 'Georgetown', tag: 'Full Service' },
  { name: 'Leander', tag: 'Full Service' },
  { name: 'Kyle', tag: 'Extended' },
  { name: 'Buda', tag: 'Extended' },
  { name: 'Hutto', tag: 'Extended' },
  { name: 'Manor', tag: 'Extended' },
  { name: 'San Marcos', tag: 'Extended' },
  { name: 'Bastrop', tag: 'Extended' },
];

export default function ServiceAreas() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section id="service-areas" className="py-28 bg-[#0D0D0D]">
      <div className="max-w-7xl mx-auto px-8">
        {/* Header */}
        <div ref={ref} className={`text-center mb-16 reveal ${visible ? 'visible' : ''}`}>
          <p className="eyebrow mb-5">Where We Work</p>
          <h2 className="text-5xl md:text-6xl font-bold text-white leading-tight mb-6"
            style={{ fontFamily: 'Playfair Display, serif' }}>
            Serving Businesses Across<br />
            <em className="not-italic text-gradient-gold">the Capital Region</em>
          </h2>
          <span className="gold-bar mx-auto block mb-6" />
          <p className="text-white/45 text-base max-w-2xl mx-auto leading-relaxed">
            Custom signs for retail, office buildings, restaurants, and commercial properties throughout Austin and Central Texas — with full permitting support in every city we serve.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          {/* Map — dominant presence */}
          <div className="relative">
            <div className="w-full h-[520px] overflow-hidden" style={{ border: '1px solid #2A2A2A' }}>
              <iframe
                title="Capital Area Signs Austin TX Service Area Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d220838.0396282671!2d-97.87467449746155!3d30.267752872289657!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8644b599a0cc032f%3A0x5d9b464bd469d57a!2sAustin%2C%20TX!5e0!3m2!1sen!2sus!4v1710000000000"
                width="100%" height="100%"
                style={{ border: 0, filter: 'grayscale(100%) contrast(1.1) brightness(0.85)' }}
                allowFullScreen loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            {/* Map overlay badge */}
            <div className="absolute bottom-4 left-4 bg-[#0D0D0D]/95 border border-[#C4962A]/20 px-5 py-4">
              <div className="flex items-center gap-2 mb-1">
                <i className="ri-map-pin-2-fill text-[#C4962A] text-sm" />
                <p className="text-white text-sm font-bold">Austin, TX — Central Texas</p>
              </div>
              <p className="text-white/40 text-xs">Serving 12+ cities across the region</p>
            </div>
          </div>

          {/* Cities + local copy */}
          <div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mb-8">
              {cities.map((city) => (
                <div key={city.name}
                  className={`px-4 py-4 border transition-colors group cursor-pointer ${
                    city.featured
                      ? 'border-[#C4962A]/50 bg-[#C4962A]/5'
                      : 'border-white/8 bg-[#161616] hover:border-[#C4962A]/30'
                  }`}>
                  <div className="flex items-center gap-2 mb-1">
                    <i className={`ri-map-pin-2-fill text-xs ${city.featured ? 'text-[#C4962A]' : 'text-white/20 group-hover:text-[#C4962A]/60'} transition-colors`} />
                    <p className={`font-bold text-sm ${city.featured ? 'text-[#C4962A]' : 'text-white/70'}`}>
                      {city.name}
                    </p>
                  </div>
                  <p className="text-white/25 text-xs ml-4">{city.tag}</p>
                </div>
              ))}
            </div>

            {/* Local reinforcement */}
            <div className="bg-[#161616] border border-white/5 p-8">
              <p className="eyebrow mb-4">Local Expertise</p>
              <h3 className="text-xl font-bold text-white mb-4 leading-tight"
                style={{ fontFamily: 'Playfair Display, serif' }}>
                We Know Austin Better Than Anyone
              </h3>
              <p className="text-white/45 text-sm leading-relaxed mb-6">
                From downtown Austin storefronts to Round Rock commercial parks, we understand local permit offices, HOA requirements, and zoning codes — meaning faster approvals and on-time installs for your business.
              </p>
              <a href="#quote" className="btn-gold">
                Get a Local Quote
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
